import React from "react";
import DefaultLayout from "../Layout/DefaultLayout";
import { ConfigurationContainer } from "./AdminStyle.styled";
import RawMaterials from "./config/rawMaterials/RawMaterials";

const AdminProducts = () => {
  return (
    <DefaultLayout browserTitle="Inventory">
      <ConfigurationContainer data-aos="fade-right">
        <h3>Raw Material Management</h3>
        <RawMaterials />
      </ConfigurationContainer>
    </DefaultLayout>
  );
};

export default AdminProducts;
